import { api } from '@/scripts/api';

export const LandingPageService = {

    get(id, config = {}) {

        return new Promise((resolve, reject) => {

            const service = '/service/LandingPages';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });

    },

    getAll(config = {}) {

        return new Promise((resolve, reject) => {

            const service = '/service/LandingPages';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });

    },

    post(payload) {

        return new Promise((resolve, reject) => {
            api
                .post('/api/LandingPages', payload)
                .then(resolve)
                .catch(reject);
        });

    },

    patch(id, payload) {

        return new Promise((resolve, reject) => {
            const service = `/api/LandingPages/${ id }`;

            api.patch(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    delete(id) {

        return new Promise((resolve, reject) => {
            const service = `/api/LandingPages/${ id }`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });

    },

    deleteAll(ids) {

        return new Promise((resolve, reject) => {
            api
                .delete('/api/LandingPages', ids)
                .then(resolve)
                .catch(reject);
        });

    },

    duplicate(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPages/${ id }/Duplicate`;

            api
                .post(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    publish(id) {

        return new Promise((resolve, reject) => {

            const service = `/api/LandingPages/${ id }/Publish`;

            api
                .post(service)
                .then(resolve)
                .catch(reject);
        });

    },

    unpublish(id) {

        return new Promise((resolve, reject) => {
            const service = `/api/LandingPages/${ id }/Unpublish`;

            api
                .post(service)
                .then(resolve)
                .catch(reject);
        });

    },
}
